import // useGetBusinessEntityDetailsQuery,
"../../../../graphql/generated";
import { useQueryClient } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { ShipmentLocationInputData } from "../../../../redux/slices/Types";
import ReceiverForm, { ReceiverFormProps } from "./ReceiverForm";
import {
  editShipmentLocationInput,
  setCustomer,
  setReceiverGoods,
} from "../../../../redux/slices/shipment/ShipmentForm.slice";
import {
  GoodDistributionInput,
  useGetBusinessEntityDetailsQuery,
} from "../../../../graphql/generated";

type ReceiverContainerProps = Omit<
  ReceiverFormProps,
  | "onChange"
  | "onReceivedGoodsChange"
  | "storageFacilities"
  | "shipmentLocation"
  | "onRequestBestBuyRanking"
> & {
  receiver: ShipmentLocationInputData;
  onChange?: (receiver: ShipmentLocationInputData) => void;
};

export default function ReceiverFormContainer({
  receiver: receiverLocation,
  onChange,
  ...props
}: ReceiverContainerProps) {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const handleChange = async (
    updatedReceiverLocation: ShipmentLocationInputData
  ) => {
    if (onChange) {
      onChange(updatedReceiverLocation);
    } else {
      dispatch(
        editShipmentLocationInput({
          location: updatedReceiverLocation,
        })
      );
      // Select the customer automatically if the receiver has a parent
      if (
        updatedReceiverLocation.receiver &&
        updatedReceiverLocation.receiver !== receiverLocation.receiver
      ) {
        const receiver = await queryClient.fetchQuery(
          useGetBusinessEntityDetailsQuery.getKey({
            id: updatedReceiverLocation.receiver,
          }),
          useGetBusinessEntityDetailsQuery.fetcher({
            id: updatedReceiverLocation.receiver,
          })
        );
        if (receiver.businessEntityById?.parentBusinessEntityId) {
          dispatch(
            setCustomer(receiver.businessEntityById.parentBusinessEntityId)
          );
        }
      }
    }
  };

  // Received-goods updates are applied as a partial patch keyed by location id,
  // so a concurrent async write (e.g. the defaulted delivery window) is never
  // clobbered by a stale full-location snapshot.
  const handleReceivedGoodsChange = (
    receivedGoods: GoodDistributionInput[]
  ) => {
    if (onChange) {
      onChange({ ...receiverLocation, receivedGoods });
    } else {
      dispatch(
        setReceiverGoods({ _id: receiverLocation._id, receivedGoods })
      );
    }
  };

  return (
    <div>
      <ReceiverForm
        shipmentLocation={receiverLocation}
        onChange={handleChange}
        onReceivedGoodsChange={handleReceivedGoodsChange}
        {...props}
      />
    </div>
  );
}
